module.exports = __webpack_public_path__ + "d7eeba687cd5fa3c1a153f2ba6b3dfaa.gif";